export default {
  videoList: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos`,
  videoDetail: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/{{videoId}}`,
  videoProducts: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/{{videoId}}/product_details`,
  videoAssociations: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/{{videoId}}/video_associations`,
  multiPublishVideos: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/multi_publish`,
};
